import * as React from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import DashBoard from "pages/master/dashboard"
import WorkSpace from "pages/master/workspace"
import { useAuth } from "contexts/auth"

const PageRoutes = () => {
  const { user } = useAuth();
  const [routes, setRoutes] = React.useState([]);
  var defaultPage = <DashBoard></DashBoard>;



  const allRouters = [
     { element: <Route path="workspace" element={<WorkSpace></WorkSpace>} />, permission: "" },

    { element: <Route path="*" element={defaultPage} />, permission: "" },
  ]









  React.useEffect(() => {


    var permissions = user.permissions ?? [];

    var items = [...allRouters];

    setRoutes(items);
  }, [user])





















  return (
    <Routes>

      {routes.map(x => {

        var element = x?.element;
        return element;

      })}
     
    </Routes>
  );
};

export default React.memo(PageRoutes);
